import { setStoreConfig } from '../store/store';
import CalendarEventsStoreConfig from '../store/schema/CalendarEventsStoreConfig';

/**
 * Intialize calendar events store config.
 */
export default function initializeStoreConfig(storeConfig: CalendarEventsStoreConfig) {
    setStoreConfig(storeConfig);
}
